import React from "react";
import testimonialImage from "../../../Images/testimonials.svg";
import { ChevronLeft, ChevronRight, Star } from "lucide-react";

const Testimonials = () => {
  const testimonials = [
    {
      title: "Amazing Courses",
      rating: 5,
      feedback:
        "Lorem ipsum is simply free text dolor sit amet, consectetur notted adipisicing elit sed do eiusmod tempor incididunt ut labore et dolore.",
      name: "Christine Eve",
      course: "Cardiology Course",
      image: testimonialImage,
    },
    {
      title: "Excellent Teachers",
      rating: 5,
      feedback:
        "The instructors were very knowledgeable and supportive throughout the entire course. Highly recommended for anyone looking to upskill.",
      name: "David Warner",
      course: "Nursing Program",
      image: testimonialImage,
    },
    {
      title: "Practical Training",
      rating: 5,
      feedback:
        "Loved the hands-on approach! The classes were engaging, and I gained real-world medical skills I can use immediately.",
      name: "Sophia Lee",
      course: "Clinical Skills",
      image: testimonialImage,
    },
  ];

  return (
    <section className="py-20 bg-white px-6 md:px-16 lg:px-24 text-center">
      {/* Header */}
      <div className="mb-14">
        <h2 className="text-3xl md:text-4xl font-bold text-slate-700">
          What Students Say <span className="text-[#F2542D]">About Us</span>
        </h2>
        <p className="text-teal-800 text-base font-medium mt-3">
          Our Testimonials
        </p>
      </div>

      {/* Testimonials Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 justify-items-center">
        {testimonials.map((item, index) => (
          <div
            key={index}
            className="bg-white w-full max-w-sm rounded-xl shadow-[0_4px_25px_rgba(0,0,0,0.08)] p-8 text-left hover:shadow-[0_6px_30px_rgba(0,0,0,0.1)] transition-all duration-300"
          >
            <h3 className="text-lg font-semibold text-zinc-800 mb-3">
              {item.title}
            </h3>

            <div className="flex items-center gap-1 mb-4 text-yellow-400">
              {Array.from({ length: item.rating }).map((_, i) => (
                <Star key={i} size={16} fill="currentColor" />
              ))}
            </div>

            <p className="text-zinc-600 text-sm leading-6 mb-6">
              {item.feedback}
            </p>

            <div className="flex items-center mt-auto">
              <img
                src={item.image}
                alt={item.name}
                className="w-14 h-14 rounded-full object-cover border border-gray-200"
              />
              <div className="ml-4">
                <p className="text-gray-900 text-base font-semibold">
                  {item.name}
                </p>
                <p className="text-neutral-500 text-sm">{item.course}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Navigation Arrows */}
      <div className="flex justify-center gap-4 mt-12">
        <button className="w-12 h-12 flex items-center justify-center bg-gray-100 hover:bg-gray-200 rounded-full transition-all">
          <ChevronLeft className="text-gray-700" />
        </button>
        <button className="w-12 h-12 flex items-center justify-center bg-teal-500 hover:bg-teal-600 rounded-full transition-all">
          <ChevronRight className="text-white" />
        </button>
      </div>
    </section>
  );
};
export default Testimonials;
